import 'bootstrap/dist/css/bootstrap.min.css';
import './FinanceCalculatorForm.scss';

import { Col, Row } from "reactstrap";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { AppBar, Button, Checkbox, FormControl, FormControlLabel, Tooltip } from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';
import MileageInput from '../../Forms/MileageInput/MileageInput';
import MoneyInput from '../../Forms/MoneyInput/MoneyInput';
import PercentInput from '../../Forms/PercentInput/PercentInput';
import RegNoInput from '../../Forms/RegNoInput/RegNoInput';
import TermInput from '../../Forms/TermInput/TermInput';
import CreditRatingToggle from '../../Forms/CreditRatingToggle/CreditRatingToggle';
import { CreditRatingApr, CreditRatingFields } from '../../../models/credit-rating.model';
import { IFinanceCalculatorState } from '../../../models/finance-calculator.model';
import config from '../../../config';
import { useEffect } from 'react';
import VehicleSelect from '../../Forms/VehicleSelect/VehicleSelect';
// import ControllerInput from '../../Forms/ControllerInput/ControllerInput';

const FinanceCalcForm = ({ state, updateState }: {state: IFinanceCalculatorState, updateState: React.Dispatch<any>}) => {
  // const [submitted, setSubmitted] = useState(false);
  const cssRow = "mb-3";
  const cssCol = "mb-3";
  const errProductType = "One of HP or PCP required";
  const errTerm = "Term must be between 12 and 60";
  const lblVehicle = "Do you have a particular vehicle in mind?";
  const lblReg = "Do you know the vehicle registration?";
  const uiApr = CreditRatingApr;

  const isHPRequired = () => {
    return !getValues("showPCP");
  };

  const isPCPRequired = () => {
    return !getValues("showHP");
  };

  const isTermValid = () => {
    const term = getValues("term");
    return (12 <= term) && (term <= 60);
  };

  const registerOptions = {
    cashPrice: { required: "Cash Price is required" },
    deposit: { required: "Deposit is required" },
    term: { required: "Term is required" },
    derivative: {
      required: "Vehicle is required",
      /*
      validate: {
        hasRegNo: (value: string) => (!state.formdata.vehicleBased || (state.formdata.knownRegNo && value)) ? true : false,
      },
      */
    },
    regNo: {
      required: "Registration Number is required",
      /*
      validate: {
        hasRegNo: (value: string) => (!state.formdata.vehicleBased || (state.formdata.knownRegNo && value)) ? true : false,
      },
      */
      minLength: {
        value: 3,
        message: "Reg No must have at least 3 characters"
      }
    }
  };

  const { control, handleSubmit, formState: { errors, isValid }, getValues, register, setValue, watch } = useForm({
    defaultValues: state.formdata
  });
  const watchAllFields = watch(); // when pass nothing as argument, you are watching everything
  const handleError = (errors: any) => { };

  const onSubmit: SubmitHandler<any> = data => {
    // For some reason the vehicle stuff isn't flowing through to here, so put it in manually?
    // console.log("onSubmit: state.formdata to " + JSON.stringify(state.formdata));
    const mergedFormData = {...data, identity: state.formdata.identity/*, vehicle: state.formdata.vehicle, vehicleDesc: state.formdata.vehicleDesc, vehicleYear: state.formdata.vehicleYear*/};
    // console.log("onSubmit: mergedFormData to " + JSON.stringify(mergedFormData));
    updateState((prevState: IFinanceCalculatorState) => {
      const newState = { ...prevState, submitted: true, formdata: mergedFormData, resultsdata: undefined };
      // console.log("onSubmit: updateState to " + JSON.stringify(newState));
      return newState;
    });
  };

  const allErrors = () => {
    let res = "";
    if (errors?.cashPrice && errors?.cashPrice.message) {
      res = res + errors?.cashPrice.message + ", ";
    }
    if (errors?.derivative && errors?.derivative.message) {
      res = res + errors?.derivative.message + ", ";
    }
    if (errors?.regNo && errors?.regNo.message) {
      res = res + errors?.regNo.message + ", ";
    }
    if (errors?.showHP && errors?.showHP.message) {
      res = res + errors?.showHP.message + ", ";
    }
    if (errors?.showPCP && errors?.showPCP.message) {
      res = res + errors?.showPCP.message + ", ";
    }
    if (errors?.term && errors?.term.message) {
      res = res + errors?.term.message + ", ";
    }
    return res;
  };

  const handleCreditRatingChange = (e: any) => {
    // console.log("creditRating (before) = " + getValues("creditRating"));
    setValue("creditRating", e.target.value)
    setValue("apr", uiApr.get(e.target.value) as number | 9.9);
    // console.log("creditRating (after) = " + getValues("creditRating"));
  };

  const handlePCPChange = (e: any) => setValue("showPCP", e.target.checked);

  const handleHPChange = (e: any) => setValue("showHP", e.target.checked);

  const handleKnownRegNoChange = (e: any) => setValue("knownRegNo", e.target.checked);

  const handleVehicleBasedChange = (e: any) => {
    setValue("vehicleBased", e.target.checked);
    setValue("showPCP", e.target.checked);
  };

  const handleDerivativeChange = (val: any) => setValue("derivative", val);

  const handleDerivativeEdit = () => setValue("derivative", undefined);

  const problemsExist = () => {
    return false;
  }

  /*
  const problemsExist0 = () => {
    let res = false;
    const curr = getValues();
    if (curr.vehicleBased) {
      if (curr.knownRegNo) {
        if (!curr.regNo) {
          res = true;
        }
      } else {
        // if (!state.formdata.identity?.derivative) {
        if (!curr.derivative) {
          res = true;
        }
      }
    }
    // console.log("problemsExist: " + JSON.stringify(getValues()) + ", res = " + res);
    return res;
  }
  */
  useEffect(() => {
    // console.log("FinanceCalcForm.useEffect");

    const fetchCreditRatings = () => {
        fetch(config.REACT_APP_BASE_URL + "/assets/data/creditRatings.json", {
            method: "get",
            headers: {
                "Accept": "application/json"
            }
        })
            .then((res) => res.json())
            .then((res) => {
                // console.log("fetchCreditRatings: " + JSON.stringify(res));
                if (res) {
                  uiApr.set(CreditRatingFields.poor, res?.poor);
                  uiApr.set(CreditRatingFields.fair, res?.fair);
                  uiApr.set(CreditRatingFields.good, res?.good);
                  uiApr.set(CreditRatingFields.excellent, res?.excellent);
                  setValue("apr", uiApr.get(getValues("creditRating")) as number);
                }
            })
    }

    fetchCreditRatings();

    // console.log("useEffect: " + JSON.stringify(state.formdata))
  }, [uiApr, setValue, getValues]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit, handleError)} className="financeCalculatorForm">
        <fieldset disabled={state.submitted} className={state.submitted ? "fieldset-submitted": ""}>
          <Row className={cssRow} key="row-credit-rating">
            <Col>
              <span className="creditRating">My credit rating is</span>
            </Col>
            <Col>
              <FormControl sx={{ m: 0, width: { sm: 220 } }}>
                <CreditRatingToggle
                  name="creditRating"
                  control={control}
                  changeEvent={handleCreditRatingChange}
                  label={""}
                />
              </FormControl>
            </Col>
          </Row>

          <Row className="align-items-center" key="row-product-types">
            <Col md={2}>
            </Col>
            <Col md={3}>
              <span className="showMe rightAlign">Show me</span>
            </Col>
            <Col md={2}>
              <FormControl sx={{ m: 0 }}>
                <Controller
                  key="known-show-hp"
                  name="showHP"
                  rules={{ required: { message: errProductType, value: isHPRequired() } }}
                  control={control}
                  render={({ field }) => <FormControlLabel {...field} label="HP" labelPlacement="start" control={
                    <Checkbox onChange={handleHPChange} checked={watchAllFields.showHP} />
                  } />}
                />
              </FormControl>
            </Col>
            <Col md={2}>
              <FormControl sx={{ m: 0 }}>
                <Controller
                  key="known-show-pcp"
                  name="showPCP"
                  rules={{ required: { message: errProductType, value: isPCPRequired() } }}
                  control={control}
                  render={({ field }) => <FormControlLabel {...field} label="PCP" labelPlacement="start" control={
                    <Checkbox onChange={handlePCPChange} disabled={!watchAllFields.vehicleBased} checked={watchAllFields.showPCP} />
                  } />}
                />
              </FormControl>
            </Col>
            <Col md={3}>
            </Col>
          </Row>

          <Row className={cssRow} key="row-vehicle-based">
            <Col>
              <FormControl sx={{ m: 0 }}>
                <Controller
                  key="vehicle-based"
                  name="vehicleBased"
                  control={control}
                  render={({ field }) =>
                    <FormControlLabel labelPlacement="start" label={lblVehicle} {...field} control=
                      {<Checkbox onChange={handleVehicleBasedChange} checked={watchAllFields.vehicleBased} />}
                    />
                  }
                />
              </FormControl>
            </Col>
          </Row>

          {(watchAllFields.vehicleBased &&
            <>
              <Row className={cssRow} key="row-known_regno">
                <Col>
                  <FormControl sx={{ m: 0 }}>
                    <Controller
                      key="known-reg-no-controller"
                      name="knownRegNo"
                      control={control}
                      render={({ field }) =>
                        <FormControlLabel labelPlacement="start" label={lblReg} {...field} control=
                          {<Checkbox onChange={handleKnownRegNoChange} checked={watchAllFields.knownRegNo} />}
                        />
                      }
                    />
                  </FormControl>
                </Col>
              </Row>

              <Row className={cssRow} key="row-regno">
                <Col>
                {watchAllFields.knownRegNo ?
                  (
                    <FormControl sx={{ m: 0, width: { xs: 200 } }}>
                      <RegNoInput
                        key="reg-no-input"
                        {...register("regNo", registerOptions.regNo)}
                        control={control}
                        label={"Registration Number"}
                      />
                    </FormControl>
                  ) : 
                  (
                    <FormControl sx={{ m: 0, width: { xs: 450 } }}>
                      <VehicleSelect 
                        key="vehicle-select"
                        {...register("derivative", registerOptions.derivative)}
                        control={control}
                        label={"Vehicle"}
                        mainstate={state}
                        onChange={handleDerivativeChange}
                        onEdit={handleDerivativeEdit}
                        updateMainState={updateState}
                      />
                    </FormControl>
                  )
                }
                </Col>
              </Row>
            </>
          )}

          <Row key="row-monetary">
            <Col className={cssCol} sm={6}>
              <FormControl sx={{ m: 0, width: { xs: 125 } }}>
                <MoneyInput
                  key="cash-price" 
                  // name="cashPrice"
                  {...register("cashPrice", registerOptions.cashPrice)}
                  control={control}
                  label={"Cash Price"}
                />
              </FormControl>
            </Col>
            <Col className={cssCol} sm={6}>
              <FormControl sx={{ m: 0, width: { xs: 125 } }}>
                <MoneyInput
                  key="deposit" 
                  // name="deposit"
                  {...register("deposit", registerOptions.deposit)}
                  control={control}
                  label={"Deposit"}
                />
              </FormControl>
            </Col>
          </Row>

          {(watchAllFields.vehicleBased &&
            <Row key="row-mileage">
              <Col className={cssCol} sm={6}>
                <FormControl sx={{ m: 0, width: { xs: 125 } }}>
                  <MileageInput
                    key="current-mileage" 
                    name="currentMileage"
                    control={control}
                    label={"Mileage (current)"}
                  />
                </FormControl>
              </Col>
              <Col className={cssCol} sm={6}>
                <FormControl sx={{ m: 0, width: { xs: 125 } }}>
                  <MileageInput
                    key="annual-mileage" 
                    name="annualMileage"
                    control={control}
                    label={"Mileage (annual)"}
                  />
                </FormControl>
              </Col>
            </Row>
          )}

          <Row sm={12} key="row-term">
            <Col className={cssCol} sm={6}>
              <FormControl sx={{ m: 0, width: { sm: 125 } }}>
                <TermInput
                  key="term-input" 
                    // name="term"
                  {...register("term", registerOptions.term)}
                  rules={{ required: { message: errTerm, value: isTermValid() } }}
                  control={control}
                  label={"Term"}
                />
              </FormControl>
            </Col>
            <Col className={cssCol} sm={6}>
              <FormControl sx={{ m: 0, width: { sm: 125 } }}>
                <PercentInput
                  key="apr-percent-input" 
                  name="apr"
                  control={control}
                  label={"APR rate"}
                  disabled={(config.REACT_APP_CUSTOM_APR !== "true")}
                />
              </FormControl>
            </Col>
          </Row>

          <Row className={cssRow + " debug"}>
            <Col>
              <FormControl sx={{ m: 0 }}>
                <div>
                  {JSON.stringify(getValues())}
                </div>
              </FormControl>
            </Col>
          </Row>

          <div className="appBarSpacer">&nbsp;</div>

          <AppBar position="fixed" sx={{ top: 'auto', bottom: 0, background: (state.mode === 'dark' ? 'rgba(33,33,33,0.7)' : 'rgba(255,255,255,0.7)'), boxShadow: 'none' }}>
            <Row sm={12} className={cssRow} key="row-submit">
              <Col sm={12}>
                <FormControl sx={{ m: 0, width: { sm: 120 } }}>
                  {!state.submitted && (
                    <Button type="submit" variant="contained" color={isValid ? "primary" : "warning"} disabled={problemsExist()}>Submit&nbsp;
                      {!isValid && false && (
                        <Tooltip title={allErrors()} placement="right">
                          <WarningIcon />
                        </Tooltip>
                      )}
                    </Button>
                  )}
                </FormControl>
              </Col>
            </Row>

            <ul className="errorList">
              <li>
                <small className="text-danger">
                  {watchAllFields.vehicleBased && watchAllFields.knownRegNo && errors?.regNo && errors.regNo.message}
                </small>
              </li>
              <li>
                <small className="text-danger">
                  {watchAllFields.vehicleBased && !watchAllFields.knownRegNo && errors?.derivative && errors.derivative.message}
                </small>
              </li>
              <li>
                <small className="text-danger">
                  {errors?.cashPrice && errors.cashPrice.message}
                </small>
              </li>
              <li>
                <small className="text-danger">
                  {(errors?.showHP && errors.showHP.message) || (errors?.showPCP && errors.showPCP.message)}
                </small>
              </li>
              <li>
                <small className="text-danger">
                  {errors?.term && errors.term.message}
                </small>
              </li>
            </ul>
          </AppBar>

        </fieldset>
      </form>
    </>

  );
};

export default FinanceCalcForm;
